import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

export class WaitingListAlert extends Component {
  static propTypes = {
    onPay: PropTypes.func,
    waitingList: PropTypes.object,
    downloadReceipt: PropTypes.func
  };

  constructor (props) {
    super(props)
    this.state = {
      showDetails: false,
      payment: 'SPORTELLO_CONTANTI'
    }
  }

  render () {
    const {
      id,
      parkTicketType,
      Subscriptions,
      markStartDate,
      numberOfMonths
    } = this.props.waitingList

    const subscription = Subscriptions[0]
    return (
      <div
        className={'alert alert-success'}
        role="alert"
      >
        <div>
          {!!this.state.showDetails && (
            <React.Fragment>
              <div className="row">
                <div className="col-md-8">
                  <strong>{parkTicketType.name}</strong>
                </div>
                <div className="col-md-4 text-right">
                  <strong>ZON{parkTicketType.Areas.length > 1 ? 'A' : 'E'}: </strong>
                  {parkTicketType.Areas.map(item => item.name + ' ')}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <strong>TARG{subscription.Vehicles.length > 1 ? 'HE' : 'A'}: </strong>
                  {subscription.Vehicles.map(item => item.plate_number + ' ')}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  Valido dal <strong>{moment(markStartDate).startOf('month').format('L')}</strong> al <strong>{moment(markStartDate).add(numberOfMonths > 1 ? numberOfMonths - 1 : 0, 'months').endOf('month').format('L')}</strong>
                </div>
              </div>

              <div style={{marginTop: '2rem'}}>
                <h4>
                  Totale da pagare: €{' '}
                  {Number(subscription.price).toLocaleString('it-IT', {
                    minimumFractionDigits: 2, maximumFractionDigits: 2
                  })}
                </h4>
              </div>
              <from>
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      name="method"
                      value="SPORTELLO_POS"
                      onChange={() => this.setState({payment: 'SPORTELLO_POS'})}
                      checked={this.state.payment === 'SPORTELLO_POS'}
                      required
                    />
                    POS
                  </label>
                </div>
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      name="method"
                      value="SPORTELLO_CONTANTI"
                      onChange={() => this.setState({payment: 'SPORTELLO_CONTANTI'})}
                      checked={this.state.payment === 'SPORTELLO_CONTANTI'}
                      required
                    />
                    CONTANTI
                  </label>
                </div>
              </from>
              <button
                style={{marginRight: '1rem'}}
                className="btn btn-info"
                onClick={() => this.props.onPay(this.props.waitingList, this.state.payment)}>Genera Abbonamento</button>
              <button
                className="btn btn-secondary"
                onClick={() =>
                  this.setState({ showDetails: false })
                }
              >
                Chiudi Dettagli
              </button>
            </React.Fragment>
          )}

          {!this.state.showDetails && (
            <React.Fragment>
                <div style={{marginLeft: '1rem', marginBottom: '0.5rem'}}>
                  Questo Utente ha ottenuto un abbonamento: <strong>{parkTicketType.name}</strong>
                  {' '}tramite la lista d'attesa: <strong>N.{id}</strong>
                </div>
              <button
                style={{marginLeft: '1rem'}}
                className="btn btn-secondary"
                onClick={() => this.setState({ showDetails: true })}
              >
                Mostra Dettagli
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Alert/WaitingListAlert.js